import React from "react";
import { Phone, Mail, Linkedin } from "lucide-react";

const ResumeHeader = ({ name, title, photo, contact }) => (
  <header className="relative px-5 sm:px-8 lg:px-12 pt-10 pb-7">
    {/* RÉSUMÉ label — centered above on mobile, top-right on larger screens */}
    <span
      className="block text-center mb-3 sm:mb-0 sm:absolute sm:top-6 sm:right-8 lg:right-12 text-[var(--ink)]"
      style={{ fontFamily: "'Oswald', sans-serif", fontWeight: 500, fontSize: "clamp(1.3rem, 2.4vw, 2rem)", letterSpacing: "0.14em" }}
    >
      {name.top}
    </span>

    <div className="flex flex-col sm:flex-row items-center sm:items-start gap-8">
      <div className="shrink-0">
        <div className="h-[276px] w-[244px] sm:h-[330px] sm:w-[292px] rounded-lg overflow-hidden shadow-lg ring-1 ring-black/10 bg-[var(--ink-dark)]">
          <img src={photo} alt="Trent Roddan" className="h-full w-full object-cover object-top" />
        </div>
      </div>

      <div className="flex-1 min-w-0 text-center sm:text-left flex flex-col justify-center sm:pt-16">
        <h1
          className="text-[var(--ink)] leading-[1.05]"
          style={{ fontFamily: "'Oswald', sans-serif", fontWeight: 500, letterSpacing: "0.01em" }}
        >
          <span
            className="block text-[var(--ink-dark)] pb-1"
            style={{ fontWeight: 500, fontSize: "clamp(2rem, 8vw, 4.6rem)", lineHeight: 1.05 }}
          >
            {name.full}
          </span>
        </h1>
        <p
          className="mt-3.5 text-[var(--text)] uppercase font-medium"
          style={{ letterSpacing: "0.22em", fontSize: "clamp(0.6rem, 1.4vw, 0.82rem)" }}
        >
          {title}
        </p>

        <div className="mt-6 pt-5 border-t border-[var(--line)] flex flex-col items-center sm:items-start gap-y-2.5 text-[13px] text-[var(--text)]">
          <a href={contact.linkedinHref} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 hover:text-[var(--ink)] transition-colors">
            <Linkedin size={15} className="text-[var(--ink)] shrink-0" /> {contact.linkedin}
          </a>
          <a href={contact.emailHref} className="flex items-center gap-2.5 hover:text-[var(--ink)] transition-colors">
            <Mail size={15} className="text-[var(--ink)] shrink-0" /> {contact.email}
          </a>
          <a href={contact.mobileHref} className="flex items-center gap-2.5 hover:text-[var(--ink)] transition-colors">
            <Phone size={15} className="text-[var(--ink)] shrink-0" /> {contact.mobile}
          </a>
        </div>
      </div>
    </div>
  </header>
);

export default ResumeHeader;
